import ExplorerIcon from "../../assets/svg/explorer.svg";
import { useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { ApplicationId, vizybilityConfig } from "../../api/url";
import { jwtDecode } from "jwt-decode";
import { postGetVizyBilityToken } from "../../services/getVizyBilityToken";
import WarningModal from "../../common/WarningModel";
import { loginRequest } from "../../config/msalConfig";

const DealerPortalRedirection = () => {
  const { instance, accounts } = useMsal();
  const menuRef = useRef(null);
  const [openWarning, setOpenWarning] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleOpenWarning = () => {
    setOpenWarning(true);
    localStorage.setItem("OpenWarning", true);
  };

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const idToken = await instance.loginPopup(loginRequest);
      handleRedirectCallback(idToken.accessToken);
    } catch (error) {
      console.error("Login error:", error);
      setIsLoading(false);
    }
  };

  const handleRedirectCallback = async (response) => {
    try {
      const decodedToken = jwtDecode(response);
      if (decodedToken?.extension_UserStatus) {
        // Stop loading after processing response
        if (decodedToken.extension_UserStatus === undefined || decodedToken.extension_UserStatus === "Pending") {
          await instance.logoutPopup({
            postLogoutRedirectUri: window.location.origin,
          });
          setIsLoading(false);
          handleOpenWarning();
          localStorage.removeItem("vizy-bility-token");
          localStorage.removeItem("client_info");
        } else if (decodedToken.extension_UserStatus === "Approved") {
          let payload = new URLSearchParams({
            grant_type: vizybilityConfig.grant_type,
            username: decodedToken.extension_GenericWebUsername,
            password: decodedToken.extension_GenericWebUserPassword,
            client_id: vizybilityConfig.STS_CLIENT_ID,
            client_secret: vizybilityConfig.STS_CLIENT_SECRET,
            scope: vizybilityConfig.STS_SCOPE,
            ApplicationId: ApplicationId,
          });
          setIsLoading(true);
          postGetVizyBilityToken({
            url: vizybilityConfig.STS_SIGNIN_URL,
            payload,
          })
            .then((res) => {
              if (res?.data?.access_token) {
                localStorage.setItem("vizy-bility-token", res.data.access_token);
                localStorage.setItem("client_info", JSON.stringify(decodedToken));
                window.scrollTo(0, 0);
                setIsLoading(false);
                navigate("/dealers-portal");
              }
            })
            .catch(async (err) => {
              setIsLoading(false);
              handleOpenWarning();
              await instance.logoutPopup({
                postLogoutRedirectUri: window.location.origin,
              });
              localStorage.removeItem("vizy-bility-token");
              localStorage.removeItem("client_info");
            });
        } else {
          await instance.logoutPopup({
            postLogoutRedirectUri: window.location.origin,
          });
          setIsLoading(false);
          handleOpenWarning();

          localStorage.removeItem("vizy-bility-token");
          localStorage.removeItem("client_info");
        }
      } else {
        handleOpenWarning();
        await instance.logoutPopup({
          postLogoutRedirectUri: window.location.origin,
        });
        localStorage.removeItem("vizy-bility-token");
        localStorage.removeItem("client_info");
      }
    } catch (error) {
      console.error("Error handling redirect callback:", error);
      setIsLoading(false); // Stop loading on error
    } finally {
    }
  };

  const handleCloseWarning = () => {
    setIsLoading(false);
    setOpenWarning(false);
    localStorage.removeItem("OpenWarning");
  };

  return (
    <>
      <header className={`sticky top-0 z-[100] header-bg transition-colors duration-300`} ref={menuRef}>
        {isLoading ? (
          <div className="absolute w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center">
            <span class="loader"></span>
          </div>
        ) : null}
        <div className="bg-[#292929]">
          <div className=" max-w-[1440px] mx-auto flex items-center justify-between md:px-[3rem] px-[1rem]">
            <div className="flex items-center"></div>

            <div className="flex items-end py-[20px] cursor-pointer " onClick={handleLogin}>
              <span className="text-[16px] font-normal font-[Roboto] text-white">DEALER PORTAL</span>
              <img src={ExplorerIcon} alt="" className="w-[30px] ml-[14px]" />
            </div>
          </div>
        </div>
      </header>
      <WarningModal open={openWarning} handleClose={handleCloseWarning} />
    </>
  );
};
export default DealerPortalRedirection;
